import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import { Tabs, Tab, Dropdown, DropdownButton, MenuItem } from 'react-bootstrap';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

// Tabs
import StaffsEditTab from './Elements/StaffsEditTab';
import StaffsTrainingTab from './Elements/StaffsTrainingTab';
import StaffsMatterTab from './Elements/StaffsMatterTab';
import StaffsEmployerTab from './Elements/StaffsEmployerTab';
import StaffsRoleTab from './Elements/StaffsRoleTab';
import StaffsMateriaMinistradaTab from './Elements/StaffsMateriaMinistradaTab';
import StaffsPendenciaTab from './Elements/StaffsPendenciaTab';
import StaffsArquivosTab from './Elements/StaffsArquivosTab';


class StaffsEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      key: 1,
      staff_data: {},
      treinamentos: {},
      provas_avulsas: {},
      funcoes: {},
      lista_funcoes: {},
      materias: {},
      lista_materias: {},
      empregadores: {},
      lista_empregadores: {},
      aulas_ministradas: {},
      pendencias: {},
      file: {},
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.exportTraining = this.exportTraining.bind(this);
    this.exportCertification = this.exportCertification.bind(this);
  }

  // Handlers
  handleNavTab(state, key) {
    var change = {};
    change[state] = key;
    this.setState(change);
    this.setState({overlay: {message: '', type: '', status: ''}});
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }
  
  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/alunos/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/alunos');
        
        if (responseJson.status === 'success') {
          var dados = responseJson.data;
          if(responseJson.data.instrutor == 1) {
            dados.instrutor_txt = 'Instrutor';
            dados.troca_index = 0;
            dados.classe_instrutor = 'success';
            dados.troca = 'Retirar status de instrução';
            dados.instrutor = 1;
          } else {
            dados.instrutor_txt = 'Não instrutor';
            dados.troca_index = 1;
            dados.classe_instrutor = 'warning';
            dados.troca = 'Trocar para instrutor';
            dados.instrutor = 0;
          }
          dados.skip_tutor_payment = Boolean(dados.skip_tutor_payment);
          self.setState({staff_data: dados});
        }
      }).then(() => {
      var url = config.get('api') + '/alunos/treinamentos/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({treinamentos: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/alunos/provas/avulsas/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({provas_avulsas: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/alunos/funcoes/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({funcoes: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/alunos/materias/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({materias: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/alunos/empregadores/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({empregadores: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/alunos/treinamentos_instrutores/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({aulas_ministradas: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/alunos/treinamentos_pendentes/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({pendencias: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/alunos/arquivos/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({file: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/funcoes/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({lista_funcoes: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/materias/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({lista_materias: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/empregadores/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({lista_empregadores: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */}); /* Lista Empregadores */ }); /* Lista Materias */ }); /* Lista Funções */ }); /* File */ }); /* Pendencias */ }); /* Aulas Ministradas */ }); /* Empregadores */ }); /* Materias */ }); /* Funções */ }); /* Treinamentos */ }); /* Treinamentos */
    });
  }

  exportTraining(url) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url + self.props.match.params.id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);       
        }
      });
    });
  }
  exportCertification(url) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + url + self.props.match.params.id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);       
        }
      });
    });
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container">
    <div className="conteudo">
      <h3 className="page-title pull-left">Edição de aluno - {this.state.staff_data.name}</h3>
      <div className="grid-buttons pull-right">
        <Link to="/tripulantes/ativos" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> Voltar</Link>
        <Dropdown id="export-data">
          <Dropdown.Toggle bsStyle={'primary'}>
            <i className="fa fa-fw fa-file-pdf-o"></i> Exportações
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <MenuItem onSelect={this.exportTraining} eventKey={'/exportar/aluno/historico/'}>Histórico do aluno</MenuItem>
            <MenuItem onSelect={this.exportTraining} eventKey={'/exportar/aluno/resumo/treinamentos/'}>Resumo de treinamento de alunos</MenuItem>
          </Dropdown.Menu>
        </Dropdown>
      </div> 
      <div className="clearfix"></div>
      <hr/>
      <Tabs activeKey={this.state.key} onSelect={this.handleNavTab.bind(this, 'key')} id={'staff-tabs'}>
        <Tab eventKey={1} title="Treinamentos">
          <StaffsTrainingTab handleAlert={this.handleAlert} provas_avulsas={this.state.provas_avulsas} treinamentos={this.state.treinamentos} staff_id={this.props.match.params.id} />
        </Tab>
        <Tab eventKey={2} title="Dados cadastrais">
          <StaffsEditTab handleAlert={this.handleAlert} staff_id={this.props.match.params.id} staff_data={this.state.staff_data} />
        </Tab>
        <Tab eventKey={3} title="Matérias autorizadas">
          <StaffsMatterTab handleAlert={this.handleAlert} lista_funcoes={this.state.lista_funcoes} lista_materias={this.state.lista_materias} materias={this.state.materias} staff_id={this.props.match.params.id} />
        </Tab>
        <Tab eventKey={4} title="Empregadores">
          <StaffsEmployerTab handleAlert={this.handleAlert} lista_empregadores={this.state.lista_empregadores} empregadores={this.state.empregadores} staff_id={this.props.match.params.id} />
        </Tab>
        <Tab eventKey={5} title="Aulas ministradas">
          <StaffsMateriaMinistradaTab handleAlert={this.handleAlert} aulas_ministradas={this.state.aulas_ministradas} staff_id={this.props.match.params.id} />
        </Tab>
        <Tab eventKey={6} title="Pendências">
          <StaffsPendenciaTab handleAlert={this.handleAlert} pendencias={this.state.pendencias} staff_id={this.props.match.params.id} />
        </Tab>
        <Tab eventKey={7} title="Funcões">
          <StaffsRoleTab handleAlert={this.handleAlert} lista_funcoes={this.state.lista_funcoes} funcoes={this.state.funcoes} staff_id={this.props.match.params.id} />
        </Tab>
        <Tab eventKey={8} title="File digital">
          <StaffsArquivosTab handleAlert={this.handleAlert} file={this.state.file} staff_id={this.props.match.params.id} />
        </Tab>
      </Tabs>  
    </div>
  </div>
</div>
    );
  }
}

export default StaffsEdit;



// WEBPACK FOOTER //
// ./src/Components/Staffs/StaffsEdit.js